import _ from 'underscore';
import $ from 'jquery';
export var View = function View(self) {
  self.subViews = self.subViews || []; // wraping backbone methods

  self.remove = _.wrap(self.remove, function (func) {
    self.removeSubViews();
    func.apply(self);
  });
  return {
    /**
     * Listen to a list of events and fire callback only once
     */
    listenToChanges: function listenToChanges(model, attributes, callback) {
      attributes = attributes.split(/\s+/);
      self.listenTo(model, 'change', function (model) {
        var changedAttributes = _.keys(model.changed);

        if (_.intersection(changedAttributes, attributes).length) {
          callback.apply(self, [model]);
        }
      });
    },
    pageTitle: function pageTitle() {
      if (_.isFunction(self.title)) {
        return self.title.apply(self);
      }

      return self.title;
    },
    // Helper for appending a view and tracking it for cleanup
    appendView: function appendView(selector, view, mode) {
      if (mode === void 0) {
        mode = 'append';
      } // support multiple views


      if (!_.isArray(view)) {
        view = [view];
      }

      var els = _.map(view, function (v) {
        return v.render().$el;
      });

      self.subViews = self.subViews.concat(view);

      if (selector instanceof $) {
        return selector[mode](els);
      }

      return self.$(selector)[mode](els);
    },
    removeSubViews: function removeSubViews() {
      return self.subViews.map(function (view) {
        return view.remove();
      });
    },
    renderTemplate: function renderTemplate(template, opts) {
      if (opts === void 0) {
        opts = {};
      }

      if (!template) {
        template = self.template;
      }

      if (_.isFunction(template)) {
        return self.$el.html(template(opts));
      } // eslint-disable-next-line


      return self.$el.html(JST[template](opts));
    }
  };
};